export default "__VITE_ASSET__077ca9db__"